
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { DataTableHeaders } from '@/types';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import {mapGetters, mapState} from 'vuex';

    @Component({
        computed: {
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
    })

    export default class UntersuchungenDatatable extends Vue {
        @Prop({ default: () => [] }) public items!: PatUntersuchung[];
        @Prop({ default: () => false }) public singleSelect!: boolean;
        @Prop({ default: () => false }) public loading!: boolean;
        @PropSync('selected') public selectedSynced!: PatUntersuchung[];

        public get headers(): DataTableHeaders<PatUntersuchung> {
            return [
                { text: 'Untersuchung', value: 'untersuchung' },
                { text: 'Abnahmedatum', value: 'abnahmedatum' },
                { text: 'Befunddatum', value: 'befunddatum' },
                { text: 'Befund', value: 'befundwerttext' },
                { text: 'Wert', value: 'befundwert' },
                /*{ text: 'Interpretation', value: 'interpretation' },*/
                { text: 'Gedruckt', value: 'druck' },
            ];
        }
    }
